import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "product-edit" };
const _hoisted_2 = { class: "card-header" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "rich-editor" };
const _hoisted_5 = { class: "param-editor" };
const _hoisted_6 = { class: "param-toolbar" };
const _hoisted_7 = { class: "sku-image-box" };
const _hoisted_8 = ["src"];
const _hoisted_9 = {
    key: 1,
    class: "sku-image-placeholder"
};
import { ref, reactive, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { Plus } from '@element-plus/icons-vue';
import { getCategoryTree, getSpuDetail, createSpu, updateSpu, listSkus, createSku, updateSku, deleteSku } from '@/api/product';
import { watch } from 'vue';
import { uploadImage } from '@/api/content';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import '@wangeditor/editor/dist/css/style.css';
import config from '@/config';
import { ensureMaxSize } from '@/utils/image';
const uploadAction = '/api/v1/upload/image';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const formRef = ref();
        const loading = ref(false);
        // 是否为编辑模式
        const isEdit = computed(() => !!route.params.id);
        // 表单数据
        const form = reactive({
            name: '',
            categoryId: 0,
            price: '',
            stockTotal: 0,
            status: 1,
            coverImg: '',
            detailHtml: '',
            paramsJson: ''
        });
        // 验证规则
        const rules = {
            name: [
                { required: true, message: '请输入商品名称', trigger: 'blur' }
            ],
            categoryId: [
                { required: true, message: '请选择商品分类', trigger: 'change' }
            ],
            price: [
                { required: true, message: '请输入商品价格', trigger: 'blur' }
            ],
            stockTotal: [
                { required: true, message: '请输入总库存', trigger: 'blur' }
            ]
        };
        const handleUpload = async (options) => {
            const file = options.file;
            const prepared = await ensureMaxSize(file);
            const res = await uploadImage(prepared);
            const url = res.data.url;
            form.coverImg = url.startsWith('http') ? url : `${config.staticBaseUrl}${url}`;
            options.onSuccess(res, file);
        };
        // (移除旧的模拟提交逻辑，统一使用下方“提交SPU”实现)
        // 重置表单
        const handleReset = () => {
            formRef.value?.resetFields();
        };
        // 加载商品数据（编辑模式）
        const loadProduct = async () => {
            if (!isEdit.value)
                return;
            try {
                const res = await getSpuDetail(Number(route.params.id));
                const { spu, skus } = res.data;
                Object.assign(form, spu);
                skuList.value = skus || [];
                // 解析参数列表
                try {
                    const parsed = spu?.paramsJson ? JSON.parse(spu.paramsJson) : [];
                    if (Array.isArray(parsed)) {
                        paramList.value = parsed.filter((it) => it && (it.key || it.value)).map((it) => ({ key: String(it.key || ''), value: String(it.value || '') }));
                    }
                }
                catch {
                    // 忽略解析错误
                }
            }
            catch (error) {
                console.error('加载商品数据失败:', error);
                ElMessage.error('加载商品数据失败');
            }
        };
        const categoryTree = ref([]);
        const skuList = ref([]);
        const paramList = ref([]);
        const editorRef = ref();
        const toolbarConfig = { excludeKeys: ['insertImage'] };
        const editorConfig = {
            MENU_CONF: {
                uploadImage: {
                    async customUpload(file, insertFn) {
                        const prepared = await ensureMaxSize(file);
                        const res = await uploadImage(prepared);
                        const url = res.data.url;
                        const abs = url.startsWith('http') ? url : `${config.staticBaseUrl}${url}`;
                        insertFn(abs);
                    }
                }
            }
        };
        const handleEditorCreated = (editor) => {
            editorRef.value = editor;
        };
        // 工具：相对路径转绝对（用于 SKU 预览）
        const imageAbs = (url) => {
            if (!url)
                return '';
            return url.startsWith('http') ? url : `${config.staticBaseUrl}${url}`;
        };
        // SKU 图片上传适配器
        const onUploadSkuImage = async (options, row) => {
            const file = options.file;
            const prepared = await ensureMaxSize(file);
            const res = await uploadImage(prepared);
            const url = res.data.url; // 相对路径
            row.imageUrl = url;
            options.onSuccess(res, file);
            // 自动保存仅图片字段（后端按非空字段更新）
            try {
                if (isEdit.value && row.id) {
                    await updateSku(row.id, { ...row, imageUrl: url });
                    ElMessage.success('SKU图片已更新');
                }
            }
            catch (e) {
                console.error('自动更新SKU图片失败', e);
            }
        };
        onMounted(async () => {
            const cats = await getCategoryTree();
            categoryTree.value = cats.data || [];
            await loadProduct();
        });
        // 参数编辑：新增/删除/同步JSON
        const addParamRow = () => {
            paramList.value.push({ key: '', value: '' });
        };
        const removeParamRow = (index) => {
            paramList.value.splice(index, 1);
        };
        watch(paramList, (val) => {
            const compact = val.filter(it => (it.key && it.key.trim()) || (it.value && it.value.trim()));
            form.paramsJson = JSON.stringify(compact);
        }, { deep: true });
        // SKU 操作
        const handleAddSku = () => {
            skuList.value.unshift({ skuCode: '', price: '', stock: 0, status: 1, commissionEnabled: 0 });
        };
        const handleSaveSku = async (row) => {
            if (!isEdit.value) {
                ElMessage.error('请先保存SPU，再维护SKU');
                return;
            }
            // 基础校验，避免后端400
            if (!row.skuCode || String(row.skuCode).trim() === '') {
                ElMessage.error('请填写SKU编码');
                return;
            }
            if (row.price === undefined || row.price === null || String(row.price).trim() === '') {
                ElMessage.error('请填写SKU价格');
                return;
            }
            if (isNaN(Number(row.price))) {
                ElMessage.error('SKU价格必须是数字');
                return;
            }
            if (row.stock === undefined || row.stock === null || Number(row.stock) < 0) {
                ElMessage.error('SKU库存不能小于0');
                return;
            }
            // 规范化必要字段
            row.status = row.status ?? 1;
            row.commissionEnabled = row.commissionEnabled ?? 0;
            const spuId = Number(route.params.id);
            try {
                if (row.id) {
                    await updateSku(row.id, row);
                }
                else {
                    await createSku(spuId, row);
                }
                ElMessage.success('保存成功');
                const list = await listSkus(spuId);
                skuList.value = list.data || [];
            }
            catch (err) {
                console.error('保存SKU失败:', err);
            }
        };
        const handleDeleteSku = async (row) => {
            if (!row.id) {
                skuList.value = skuList.value.filter((s) => s !== row);
                return;
            }
            await deleteSku(row.id);
            ElMessage.success('删除成功');
            const spuId = Number(route.params.id);
            const list = await listSkus(spuId);
            skuList.value = list.data || [];
        };
        // 提交SPU
        const handleSubmit = async () => {
            if (!formRef.value)
                return;
            try {
                await formRef.value.validate();
                loading.value = true;
                // 提交前确保 JSON 同步
                const compact = paramList.value.filter(it => (it.key && it.key.trim()) || (it.value && it.value.trim()));
                form.paramsJson = JSON.stringify(compact);
                if (isEdit.value) {
                    await updateSpu(Number(route.params.id), form);
                    ElMessage.success('更新成功');
                }
                else {
                    const res = await createSpu(form);
                    ElMessage.success('添加成功');
                    router.replace(`/product/edit/${res.data.id}`);
                }
            }
            catch (error) {
                console.error('保存失败:', error);
            }
            finally {
                loading.value = false;
            }
        };
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_tree_select = _resolveComponent("el-tree-select");
            const _component_el_radio = _resolveComponent("el-radio");
            const _component_el_radio_group = _resolveComponent("el-radio-group");
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_el_upload = _resolveComponent("el-upload");
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            const _component_el_divider = _resolveComponent("el-divider");
            const _component_el_input_number = _resolveComponent("el-input-number");
            const _component_el_switch = _resolveComponent("el-switch");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_card = _resolveComponent("el-card");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_el_card, null, {
                    header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", null, _toDisplayString(isEdit.value ? '编辑商品' : '添加商品'), 1),
                            _createVNode(_component_el_button, {
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.back()))
                            }, {
                                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                        _createTextVNode(" 返回 ", -1)
                                    ]))]),
                                _: 1
                            })
                        ])
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_component_el_form, {
                            ref_key: "formRef",
                            ref: formRef,
                            model: form,
                            rules: rules,
                            "label-width": "120px",
                            style: { "max-width": "1200px" }
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                    label: "商品名称",
                                    prop: "name"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.name,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.name) = $event)),
                                            placeholder: "请输入商品名称"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                    label: "商品分类",
                                    prop: "categoryId"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_tree_select, {
                                            modelValue: form.categoryId,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.categoryId) = $event)),
                                            data: categoryTree.value,
                                            placeholder: "请选择分类",
                                            "check-strictly": "",
                                            "render-after-expand": false,
                                            props: { label: 'name', value: 'id' }
                                        }, null, 8, ["modelValue", "data"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                    label: "参考价格",
                                    prop: "price"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.price,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.price) = $event)),
                                            placeholder: "请输入参考价格"
                                        }, {
                                            prepend: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                                    _createTextVNode(" ¥ ", -1)
                                                ]))]),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                    label: "商品状态",
                                    prop: "status"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_radio_group, {
                                            modelValue: form.status,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.status) = $event))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_radio, { label: 1 }, {
                                                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                            _createTextVNode(" 上架 ", -1)
                                                        ]))]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_el_radio, { label: 0 }, {
                                                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                                            _createTextVNode(" 下架 ", -1)
                                                        ]))]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "商品主图" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_upload, {
                                            class: "image-uploader",
                                            action: uploadAction,
                                            "show-file-list": false,
                                            "http-request": handleUpload
                                        }, {
                                            default: _withCtx(() => [
                                                (form.coverImg)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: form.coverImg,
                                                        class: "image"
                                                    }, null, 8, _hoisted_3))
                                                    : (_openBlock(), _createBlock(_component_el_icon, {
                                                        key: 1,
                                                        class: "image-uploader-icon"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(Plus))
                                                        ]),
                                                        _: 1
                                                    }))
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                    label: "富文本描述",
                                    prop: "detailHtml"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createVNode(_unref(Toolbar), {
                                                editor: editorRef.value,
                                                "default-config": toolbarConfig,
                                                mode: 'default'
                                            }, null, 8, ["editor"]),
                                            _createVNode(_unref(Editor), {
                                                modelValue: form.detailHtml,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.detailHtml) = $event)),
                                                "default-config": editorConfig,
                                                mode: 'default',
                                                onOnCreated: handleEditorCreated
                                            }, null, 8, ["modelValue"])
                                        ])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                    label: "参数信息",
                                    prop: "paramsJson"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createVNode(_component_el_button, {
                                                    size: "small",
                                                    onClick: addParamRow
                                                }, {
                                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                            _createTextVNode(" 新增参数 ", -1)
                                                        ]))]),
                                                    _: 1
                                                }),
                                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "param-hint" }, "示例：功率=15KW、扬程=32m", -1))
                                            ]),
                                            _createVNode(_component_el_table, {
                                                data: paramList.value,
                                                size: "small",
                                                border: ""
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_el_table_column, {
                                                        label: "参数名",
                                                        "min-width": "180"
                                                    }, {
                                                        default: _withCtx((scope) => [
                                                            _createVNode(_component_el_input, {
                                                                modelValue: scope.row.key,
                                                                "onUpdate:modelValue": ($event) => ((scope.row.key) = $event),
                                                                placeholder: "参数名，如：功率"
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_el_table_column, {
                                                        label: "参数值",
                                                        "min-width": "220"
                                                    }, {
                                                        default: _withCtx((scope) => [
                                                            _createVNode(_component_el_input, {
                                                                modelValue: scope.row.value,
                                                                "onUpdate:modelValue": ($event) => ((scope.row.value) = $event),
                                                                placeholder: "参数值，如：15KW"
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_el_table_column, {
                                                        label: "操作",
                                                        width: "100"
                                                    }, {
                                                        default: _withCtx((scope) => [
                                                            _createVNode(_component_el_button, {
                                                                type: "danger",
                                                                size: "small",
                                                                onClick: ($event) => (removeParamRow(scope.$index))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                                        _createTextVNode(" 删除 ", -1)
                                                                    ]))]),
                                                                _: 2
                                                            }, 1032, ["onClick"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }, 8, ["data"])
                                        ])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_divider, null, {
                                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                            _createTextVNode("SKU 列表", -1)
                                        ]))]),
                                    _: 1
                                }),
                                _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "small",
                                    style: { "margin-bottom": "10px" },
                                    onClick: handleAddSku
                                }, {
                                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                            _createTextVNode(" 新增SKU ", -1)
                                        ]))]),
                                    _: 1
                                }),
                                _createVNode(_component_el_table, {
                                    data: skuList.value,
                                    size: "small",
                                    border: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_table_column, {
                                            prop: "imageUrl",
                                            label: "图片",
                                            width: "200"
                                        }, {
                                            default: _withCtx((scope) => [
                                                _createVNode(_component_el_upload, {
                                                    class: "sku-image-uploader",
                                                    "show-file-list": false,
                                                    "http-request": (opt) => { onUploadSkuImage(opt, scope.row); }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_7, [
                                                            (scope.row.imageUrl)
                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                    key: 0,
                                                                    src: imageAbs(scope.row.imageUrl),
                                                                    class: "sku-image"
                                                                }, null, 8, _hoisted_8))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                                    _createVNode(_component_el_icon, { class: "sku-image-icon" }, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_unref(Plus))
                                                                        ]),
                                                                        _: 1
                                                                    })
                                                                ]))
                                                        ])
                                                    ]),
                                                    _: 2
                                                }, 1032, ["http-request"])
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                            prop: "skuCode",
                                            label: "SKU编码",
                                            "min-width": "160"
                                        }, {
                                            default: _withCtx((scope) => [
                                                _createVNode(_component_el_input, {
                                                    modelValue: scope.row.skuCode,
                                                    "onUpdate:modelValue": ($event) => ((scope.row.skuCode) = $event),
                                                    placeholder: "请输入SKU编码"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                            prop: "price",
                                            label: "价格",
                                            width: "130"
                                        }, {
                                            default: _withCtx((scope) => [
                                                _createVNode(_component_el_input, {
                                                    modelValue: scope.row.price,
                                                    "onUpdate:modelValue": ($event) => ((scope.row.price) = $event),
                                                    placeholder: "价格"
                                                }, {
                                                    prepend: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                            _createTextVNode(" ¥ ", -1)
                                                        ]))]),
                                                    _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                            prop: "stock",
                                            label: "库存",
                                            width: "160"
                                        }, {
                                            default: _withCtx((scope) => [
                                                _createVNode(_component_el_input_number, {
                                                    modelValue: scope.row.stock,
                                                    "onUpdate:modelValue": ($event) => ((scope.row.stock) = $event),
                                                    min: 0
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                            prop: "status",
                                            label: "上架",
                                            width: "100"
                                        }, {
                                            default: _withCtx((scope) => [
                                                _createVNode(_component_el_switch, {
                                                    modelValue: scope.row.status,
                                                    "onUpdate:modelValue": ($event) => ((scope.row.status) = $event),
                                                    "active-value": 1,
                                                    "inactive-value": 0
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                            prop: "commissionEnabled",
                                            label: "计提",
                                            width: "100"
                                        }, {
                                            default: _withCtx((scope) => [
                                                _createVNode(_component_el_switch, {
                                                    modelValue: scope.row.commissionEnabled,
                                                    "onUpdate:modelValue": ($event) => ((scope.row.commissionEnabled) = $event),
                                                    "active-value": 1,
                                                    "inactive-value": 0
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                            label: "操作",
                                            width: "200"
                                        }, {
                                            default: _withCtx((scope) => [
                                                _createVNode(_component_el_button, {
                                                    size: "small",
                                                    type: "primary",
                                                    onClick: ($event) => (handleSaveSku(scope.row))
                                                }, {
                                                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                            _createTextVNode(" 保存 ", -1)
                                                        ]))]),
                                                    _: 2
                                                }, 1032, ["onClick"]),
                                                _createVNode(_component_el_button, {
                                                    size: "small",
                                                    type: "danger",
                                                    onClick: ($event) => (handleDeleteSku(scope.row))
                                                }, {
                                                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                            _createTextVNode(" 删除 ", -1)
                                                        ]))]),
                                                    _: 2
                                                }, 1032, ["onClick"])
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }, 8, ["data"]),
                                _createVNode(_component_el_form_item, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                            type: "primary",
                                            loading: loading.value,
                                            onClick: handleSubmit
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(isEdit.value ? '更新' : '添加'), 1)
                                            ]),
                                            _: 1
                                        }, 8, ["loading"]),
                                        _createVNode(_component_el_button, { onClick: handleReset }, {
                                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                                    _createTextVNode(" 重置 ", -1)
                                                ]))]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["model"])
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
